// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xriD","rootMobile":"styles_rootMobile__34Vc8"};